import React from 'react';
import { motion } from 'framer-motion';
const companions = [{
  name: 'Yuki',
  age: 22,
  tagline: 'Elegant & Sweet',
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=500&fit=crop&crop=face',
  location: 'Japan'
}, {
  name: 'Sofia',
  age: 24,
  tagline: 'Passionate & Charming',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=500&fit=crop&crop=face',
  location: 'Russia'
}, {
  name: 'Mina',
  age: 21,
  tagline: 'Playful & Cute',
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=500&fit=crop&crop=face',
  location: 'Korea'
}, {
  name: 'Isabella',
  age: 25,
  tagline: 'Sophisticated Beauty',
  image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=500&fit=crop&crop=face',
  location: 'Brazil'
}, {
  name: 'Sakura',
  age: 23,
  tagline: 'Gentle Soul',
  image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&h=500&fit=crop&crop=face',
  location: 'Japan'
}, {
  name: 'Emma',
  age: 22,
  tagline: 'Fun & Energetic',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=500&fit=crop&crop=face',
  location: 'UK'
}, {
  name: 'Lina',
  age: 24,
  tagline: 'Graceful & Smart',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=500&fit=crop&crop=face',
  location: 'China'
}, {
  name: 'Aria',
  age: 23,
  tagline: 'Mysterious & Alluring',
  image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=500&fit=crop&crop=face',
  location: 'Singapore'
}];
export function Gallery() {
  return <section id="gallery" className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-21">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#333] to-transparent" data-id="element-22" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif text-white mb-4" data-id="element-25">
            Elite Companions
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="h-1 w-20 bg-[#D4AF37] mx-auto" data-id="element-26" />
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mt-4 text-gray-400" data-id="element-27">
            Discover your perfect match
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-28">
          {companions.map((companion, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative bg-[#111] border border-[#222] overflow-hidden hover:border-[#D4AF37]/50 transition-all duration-500" data-id="element-29">
              {/* Avatar Placeholder */}
              <div className="h-80 w-full relative overflow-hidden" data-id="element-30">
                <img src={companion.image} alt={companion.name} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-31" />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors duration-500" data-id="element-32" />

                {/* Overlay Content */}
                <div className="absolute bottom-0 left-0 w-full p-6 bg-gradient-to-t from-black via-black/80 to-transparent" data-id="element-33">
                  <div className="flex items-end justify-between mb-1" data-id="element-34">
                    <h3 className="text-2xl font-serif text-white" data-id="element-35">
                      {companion.name}
                    </h3>
                    <span className="text-[#D4AF37] font-medium" data-id="element-36">
                      {companion.age}
                    </span>
                  </div>
                  <p className="text-sm text-gray-300 mb-2" data-id="element-37">
                    {companion.location}
                  </p>
                  <p className="text-xs text-[#D4AF37] uppercase tracking-wider" data-id="element-38">
                    {companion.tagline}
                  </p>
                </div>
              </div>

              {/* Hover Glow Effect */}
              <div className="absolute inset-0 border border-[#D4AF37] opacity-0 group-hover:opacity-20 transition-opacity duration-500 pointer-events-none" data-id="element-39" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}